import React, { PropTypes, PureComponent } from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { getDefaultLanguage, getLanguage, setLanguage } from '../../services/language';

class NavigationBar extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      defaultLanguage: getDefaultLanguage(),
      language: getLanguage()
    };
    this.state.language = localStorage.getItem('language') || this.state.defaultLanguage;
    this.expand = this.expand.bind(this);
    this.min = this.min.bind(this);
    this.language = this.language.bind(this);
  }

  expand() {
    this.setState({ expanded: !this.state.expanded });
  }

  min() {
    this.setState({ expanded: false });
  }

  language(language) {
    this.min();
    this.setState({ language });
    setLanguage(language)
    window.location.reload();
  }

  render() {
    const { navModel } = this.props;
    const { expanded, language, defaultLanguage } = this.state;
    return (
      <Navbar expanded={expanded} className="navbar-custom navbar-fixed-top">
        <Navbar.Header>
          <Navbar.Brand>
            <a href="#" className="navbar-brand">Planet</a>
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.expand.bind(this)}>
            Menu <i className="fa fa-bars"></i>
          </Navbar.Toggle>
        </Navbar.Header>
        <div className="logo"></div>
        <Navbar.Collapse>
          <Nav>
            {navModel.leftLinks.map((link, index) => {
              return <NavItem onClick={this.min.bind(this)} key={index} href={'/#' + link.link}>{link.label}</NavItem>
            })}
          </Nav>
          <Nav pullRight>
            {navModel.rightLinks.map((link, index) => {
              return <NavItem onClick={this.min.bind(this)} key={index} href={'/#' + link.link}>{link.label}</NavItem>
            })}

            {
              defaultLanguage === language ? <NavItem onClick={() => this.language('en')}>EN</NavItem>
                : <NavItem onClick={() => this.language('pt')}>PT</NavItem>
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }

}

NavigationBar.propTypes = {
  brand: PropTypes.string,
  handleLeftNavItemClick: PropTypes.func,
  handleRightNavItemClick: PropTypes.func,
  navModel: PropTypes.shape({
    leftLinks: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired
      })
    ).isRequired,
    rightLinks: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired
      })
    ).isRequired
  })
};

NavigationBar.defaultProps = {
  brand: 'brand'
};

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/components/navigation/NavigationBar.js